import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { DeactivateVariables, DeactivationResponse } from "./types";

export const useDeactivate = (
  options?: UseMutationOptions<
    DeactivationResponse,
    PortalAxiosError,
    DeactivateVariables
  >
) => {
  const server = useServer();

  return useMutation<
    DeactivationResponse,
    PortalAxiosError,
    DeactivateVariables
  >((variables) => server.post("deactivation", variables), options);
};

export default useDeactivate;
